import React from 'react'
import { useState, useRef, useEffect} from 'react'; 
import { ApiCallerConnection } from '../../Api/ApiCallerConnection.jsx';
import style from  '../../Styles/Menu/Menu.module.css';
import Order from '../Order/Order.jsx';


const Menu = ({ selectedItem, setSelectedItem }) => {
  const [expandedItems, setExpandedItems] = useState({});  
  const [nav, setNav] = useState(false);  
  const itemRefs = useRef({});
  
  const toggleExpand = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));

  setTimeout(() => {
      if (itemRefs.current[itemId]) {
        itemRefs.current[itemId].scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center',
          inline: 'nearest'
        });
      }
    }, 100); 
  };

  
  const MenuItem = ({ item, level = 0 }) => {    
    const hasSubmenus = item.submenus && item.submenus.length > 0;    
    useEffect(() => {
      if (hasSubmenus) {
        itemRefs.current[item.idMenuOption] = document.getElementById(`menu-item-${item.idMenuOption}`);
      }
    }, [hasSubmenus, item.idMenuOption]);

    const handleClick = (e) => {
      setSelectedItem(item.idMenuOption);
      if (hasSubmenus) {        
        toggleExpand(item.idMenuOption);
      } else {
        setNav(!nav);
      }
    };
    return (
      <div key={item.idMenuOption} id={`menu-item-${item.idMenuOption}`} className={`${style.menuListItem} ${level > 0 ? style.subMenuItem : ''}`} >
        <div className={`${hasSubmenus ? style.menuItemWithSubmenu : style.menuItem}`} onClick={handleClick} style={{ cursor: hasSubmenus ? 'pointer' : 'default' , background:  hasSubmenus ? `url(${item.imagePath}) no-repeat center/cover` : '' }}>       
          {hasSubmenus  && ( item.name )}
          {!hasSubmenus && (
              <Order
                menuItem={item}>            
              </Order>
          )}
        </div>
        {hasSubmenus && expandedItems[item.idMenuOption] && (
          <div className={style.subMenu}>
            {item.submenus.map(subItem => (
              <MenuItem key={subItem.idMenuOption} item={subItem} level={level + 1} />
            ))}
          </div>
        )}
      </div>
    );
  };    

  const MenuList = ({ data }) => {
    return (
      <div className={style.menuWrapper}>         
        <div className={style.menu}>
          {data.submenus.map(item => (
            <MenuItem key={item.idMenuOption} item={item} level={0} />
          ))}
        </div>
      </div>
    );
  };
  return (
    <div className={style.allMenuContainer}>        
      <ApiCallerConnection method={process.env.REACT_APP_API_POST} url={process.env.REACT_APP_API_GETMENU} useAuth={false}>
        {({dataResponse, loading, error}) => (
          <div className={nav ? [style.menuContainer, style.menumobile, style.active].join(' ') : [style.menumobile]}>
            {loading && <p>Loading...</p>}
            {error && <p>Error: {error.message}</p>}              
            <MenuList data={dataResponse} />
          </div>
        )}
      </ApiCallerConnection>
    </div>
  );
}

export default Menu;